export const ROUTES = {
  home: '/',
  login: '/login',
  loginByRegistration: '/login-by-registration',
  verifyCode: '/verify-code',
  changePassword: '/change-password',
  changeEmail: '/change-email',
  resetPassword: '/reset-password',
  'resetPassword.token': {
    path: '/reset-password/:token',
    params: {
      token: true,
    },
  },
  'invite.id': {
    path: '/invite/:id',
    params: {
      id: true,
    },
  },
  'ideaManagement.panorama': {
    path: '/idea-management',
  },
  'ideaManagement.feed': {
    path: '/idea-management/feed',
  },
  'ideaManagement.feed.details': {
    path: '/idea-management/feed/:id',
    params: {
      id: true,
    },
    query: {
      title: true,
      tab: true,
    },
  },
  'ideaManagement.challengeManagement': {
    path: '/idea-management/challenge-management',
  },
  'ideaManagement.challengeManagement.new': {
    path: '/idea-management/challenge-management/new',
  },
  'ideaManagement.challengeManagement.update': {
    path: '/idea-management/challenge-management/:id',
    params: {
      id: true,
    },
  },
  'ideaManagement.publishedChallenges': {
    path: '/idea-management/published-challenges',
  },
  'ideaManagement.publishedChallenges.details': {
    path: '/idea-management/published-challenges/:id',
    params: {
      id: true,
    },
    query: {
      title: true,
      sequence: true,
    },
  },
  'ideaManagement.publishedChallenges.details/idea/details': {
    path: '/idea-management/published-challenges/:id/idea/details/:ideaId',
    params: {
      id: true,
      ideaId: true,
    },
    query: {
      ideaTitle: true,
      challenge: true,
    },
  },
  'ideaManagement.publishedChallenges.details/idea/new': {
    path: '/idea-management/published-challenges/:id/idea/new',
    params: {
      id: true,
    },
    query: {
      challenge: true,
    },
  },
  'ideaManagement.kanban': {
    path: '/idea-management/kanban',
    query: {
      idea: true,
    },
  },
  'ideaManagement.ideaList': {
    path: '/idea-management/idea-list',
  },
  'ideaManagement.ranking': {
    path: '/idea-management/ranking',
  },
  'ideaManagement.dashboard': {
    path: '/idea-management/dashboard',
  },

  profile: {
    path: '/profile',
  },
  'profile.update': {
    path: '/profile/update',
  },
  'profile.myIdeas.details': {
    path: '/profile/my-ideas/:id',
    params: {
      id: true,
    },
    query: {
      title: true,
    },
  },
  'profile.myIdeas.update': {
    path: '/profile/my-ideas/update/:id',
    params: {
      id: true,
    },
    query: {
      title: true,
    },
  },

  'adminPortal.userManagement': {
    path: '/admin-portal/user-management',
  },
  'adminPortal.template': {
    path: '/admin-portal/template',
  },
  'adminPortal.avantti': {
    path: '/admin-portal/avantti',
  },
  'adminPortal.geral': {
    path: '/admin-portal/geral',
  },

  'knowledge-trail': {
    path: '/knowledge-trail',
  },

  'knowledgeTrail.videos': {
    path: '/knowledge-trail/videos',
  },

  'knowledgeTrail.videos.ideation': {
    path: '/knowledge-trail/videos/ideation',
  },

  'knowledgeTrail.articles': {
    path: '/knowledge-trail/articles',
  },

  notifications: {
    path: '/notifications',
  },

  'projects.portfolio': {
    path: '/projects/portfolio/:id',
    params: {
      id: true,
    },
  },

  'openInnovation.startups': {
    path: '/open-innovation/startups',
  },
}
